import { useState } from 'react';
import { WidgetProps } from '@rjsf/core';
import { iconAlignLeftSvg, iconAlignMiddleSvg, iconAlignRightSvg } from '../../assets/images';

const HorizontalAlignment = (props: WidgetProps) => {
    const { label, onChange } = props;
    const [isSelected, setSelected] = useState<string>('');

    const handleHorizontalChange = (value: string) => (_event: React.MouseEvent) => {
        setSelected(value);
        onChange(value);
    };

    return (
        <div className="horizontal-alignment">
            <label id="color-picker-label">{label}</label>
            <img
                className={`horizontal-icon ${isSelected === 'left' ? 'selected-icon' : ''}`}
                id={'horizontal-left'}
                src={iconAlignLeftSvg}
                alt="horizontal-icon-left"
                onClick={handleHorizontalChange('left')}
            />
            <img
                className={`horizontal-icon ${isSelected === 'center' ? 'selected-icon' : ''}`}
                id={'horizontal-middle'}
                src={iconAlignMiddleSvg}
                alt="toggle-icon-middle"
                onClick={handleHorizontalChange('center')}
            />
            <img
                className={`horizontal-icon ${isSelected === 'right' ? 'selected-icon' : ''}`}
                id={'horizontal-right'}
                src={iconAlignRightSvg}
                alt="toggle-icon-right"
                onClick={handleHorizontalChange('right')}
            />
        </div>
    );
};

export default HorizontalAlignment;
